import React from 'react';
import { Component } from 'react';
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes/routes";
import MainNavigation from './components/navigation/mainNavigation';

class App extends Component {

  render() {
    return (
      <BrowserRouter>

        <MainNavigation />

        <Routes />
      </BrowserRouter>
    )
  }

}

export default App;
